// src/App.js
import React from 'react';
import CustomChatbot from './CustomChatbot';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* <h1>CriLeA Chatbot</h1> */}
        <CustomChatbot />
      </header>
    </div>
  );
}

export default App;

